import Offcanvas from 'bootstrap/js/dist/offcanvas';

// example importing other Bootstrap Javascript Module
import Modal from 'bootstrap/js/dist/modal';

import { initNavigation } from './modules/navigation';
import {initImageParallax} from './modules/imageParallax';
import { initOverlapSection } from './modules/overlapSection';

initNavigation();
initImageParallax();
initOverlapSection();